var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1035 14.1665H21.2493C17.3373 14.1665 14.166 17.3378 14.166 21.2498V70.8332C14.166 74.7453 17.3373 77.9165 21.2493 77.9165H42.4993",
    stroke: "#1884C7",
    strokeWidth: 5.3125,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8965 14.1665H63.7507C67.6628 14.1665 70.834 17.3378 70.834 21.2498V53.1248",
    stroke: "#1884C7",
    strokeWidth: 5.3125,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.334 22.6665V15.9373C28.334 14.9593 29.1268 14.1665 30.1048 14.1665C31.0828 14.1665 31.8906 13.3733 32.0581 12.4098C32.5829 9.39131 34.6169 3.5415 42.5007 3.5415C50.3844 3.5415 52.4184 9.39131 52.9433 12.4098C53.1108 13.3733 53.9186 14.1665 54.8965 14.1665C55.8743 14.1665 56.6673 14.9593 56.6673 15.9373V22.6665C56.6673 23.8401 55.716 24.7915 54.5423 24.7915H30.459C29.2854 24.7915 28.334 23.8401 28.334 22.6665Z",
    stroke: "#1884C7",
    strokeWidth: 5.3125,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8965 72.604L61.9798 79.6873L79.6881 61.979",
    stroke: "#1884C7",
    strokeWidth: 5.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.b036614257a2ec8493a12cd743560630.svg";
export { ForwardRef as ReactComponent };